import { getCurrentUser } from '@nextcloud/auth';
import { Folder, Permission, getDavNameSpaces, getDavProperties, davGetClient, davResultToNode, davRemoteURL, davRootPath } from '@nextcloud/files';
import { fetchTags } from './api';
const rootPath = '/systemtags';
const client = davGetClient();
const resultToNode = (node) => davResultToNode(node);
const formatReportPayload = (tagId) => `<?xml version="1.0"?>
<oc:filter-files ${getDavNameSpaces()}>
	<d:prop>
		${getDavProperties()}
	</d:prop>
	<oc:filter-rules>
		<oc:systemtag>${tagId}</oc:systemtag>
	</oc:filter-rules>
</oc:filter-files>`;
const tagToNode = function (tag) {
    return new Folder({
        id: tag.id,
        source: `${davRemoteURL}${rootPath}/${tag.id}`,
        owner: String(getCurrentUser()?.uid ?? 'anonymous'),
        root: rootPath,
        displayname: tag.displayName,
        permissions: Permission.READ,
        attributes: {
            ...tag,
            'is-tag': true,
        },
    });
};
export const getContents = async (path = '/') => {
    // List tags in the root
    const tagsCache = (await fetchTags()).filter(tag => tag.userVisible);
    if (path === '/') {
        return {
            folder: new Folder({
                id: 0,
                source: `${davRemoteURL}${rootPath}`,
                owner: getCurrentUser()?.uid,
                root: rootPath,
                permissions: Permission.NONE,
            }),
            contents: tagsCache.map(tagToNode),
        };
    }
    const tagId = parseInt(path.split('/', 2)[1]);
    const tag = tagsCache.find(tag => tag.id === tagId);
    if (!tag) {
        throw new Error('Tag not found');
    }
    const folder = tagToNode(tag);
    const contentsResponse = await client.getDirectoryContents(davRootPath, {
        details: true,
        // Only filter favorites if we're at the root
        data: formatReportPayload(tagId),
        headers: {
            // Patched in WebdavClient.ts
            method: 'REPORT',
        },
    });
    return {
        folder,
        contents: contentsResponse.data.map(resultToNode),
    };
};
